import { useAsync } from 'react-use';
import { useApi } from './useApi';

export function useProductBySymbol(symbol: string, hasAccess: boolean) {
  const { apiClient } = useApi();

  const state = useAsync(async () => {
    if (!hasAccess) return undefined;
    const newProduct = await apiClient?.getProductBySymbol(symbol);
    return newProduct;
  }, [apiClient, symbol, hasAccess]);

  return {
    product: state.value,
    ...state,
  };
}
